(function() {
  const environmentConfigs = {
    'production': {
      gtagId: 'G-XR5KK27XM2',
      logMessage: 'GA4 Production'
    },
    'staging': {
      gtagId: 'G-D0Q00KG7LR',
      logMessage: 'GA4 Staging'
    }
  };

  const currentConfig = environmentConfigs[process.env.NODE_ENV];

  if (currentConfig) {
    const head = document.getElementsByTagName("head")[0];
    const myScript = document.createElement('script');

    myScript.async = true;
    myScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${currentConfig.gtagId}`);

    var inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${currentConfig.gtagId}');
      `;
      document.head.appendChild(inlineScript);
      // console.log(currentConfig.logMessage);
  }
})();